<template>
  <div
    style="padding: 20px; position: relative; overflow: hidden; height: 100%"
  >
    <div
      style="
        border: 1px solid #e2e2e2;
        border-radius: 10px;
        overflow: hidden;
        height: 100%;
        display: flex;
        flex-direction: column;
      "
    >
      <div style="display: flex; background-color: #f6f6f6; padding: 10px 20px">
        <ul style="display: flex; align-items: center; flex: 1">
          <div
            v-if="state.model?.withholding_agent_type == 1"
            style="
              white-space: nowrap;
              background-color: #1e90ff;
              color: #fff;
              width: 18px;
              height: 18px;
              line-height: 18px;
              text-align: center;
              font-size: 11px;
              border-radius: 2px;
              margin-right: 5px;
              cursor: pointer;
            "
            title="当前算税单为外协算税单"
          >
            外
          </div>
          {{
            state.model.name
          }}
          <text
            style="color: #1e90ff"
            class="text-hover-decoration"
            @click="$onCopy(state.model.order_id)"
          >
            ({{ state.model.order_id }})
          </text>
          <c_status
            v-if="state.model.status != null && state.model.status != undefined"
            arr-name="calctax_status"
            :value="state.model.status"
            style="margin-left: 20px"
          ></c_status>
        </ul>
        <template
          v-if="state.model.withholding_agent_type === 0 && $judge_auth('69')"
        >
          <el-button
            v-if="
              state.model.id &&
              state.model.status === 0 &&
              state.model.is_submit === 0
            "
            type="primary"
            icon="Select"
            @click="onSubmit"
            size="small"
            >提交算税
          </el-button>
          <el-button
            v-if="state.model.status === 0"
            type="danger"
            icon="Close"
            link
            @click="onCancel"
            >取消算税
          </el-button>
        </template>
      </div>
      <ul
        style="padding: 20px; overflow: hidden; transition: all linear 0.2s"
        :style="{ height: state.descHeight }"
      >
        <el-descriptions
          :column="3"
          border
          size="large"
          class="desc-box"
          ref="descDom"
        >
          <el-descriptions-item label-align="right">
            <template #label>
              <div style="display: flex; align-items: center; width: 100%">
                <li
                  style="flex: 1; display: flex; align-items: center"
                  @click="onDescDomToggle"
                >
                  <el-icon
                    v-if="state.descHeight == '70px'"
                    size="22"
                    color="#1e90ff"
                    style="cursor: pointer"
                    title="查看更多信息"
                    @click="state.showMore = true"
                  >
                    <View />
                  </el-icon>
                  <el-icon
                    v-else
                    size="22"
                    color="#1e90ff"
                    style="cursor: pointer"
                    @click="state.showMore = false"
                    title="隐藏更多信息"
                  >
                    <Hide />
                  </el-icon>
                </li>
                算税单名称
              </div>
            </template>
            <div style="width: fit-content; max-width: 30vw">
              {{ state.model?.name }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="状态" label-align="right">
            <div>
              <c_status
                v-if="
                  state.model.status != null && state.model.status != undefined
                "
                arr-name="calctax_status"
                :value="state.model.status"
              ></c_status>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="所属客户" label-align="right">
            <div>
              {{ state.model?.customer_name || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="扣缴义务人" label-align="right">
            <div
              v-if="state.model?.withholding_agent_id"
              :data-type="
                state.model?.withholding_agent_type == 1 ? '供' : '扣'
              "
              :style="{
                '--dynamic-color':
                  state.model?.withholding_agent_type == 1
                    ? '#1e90ff'
                    : '#ffa500',
              }"
              style="white-space: nowrap"
              class="withholding-badge"
            >
              {{ state.model?.withholding_agent_name || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="报税类型" label-align="right">
            <div>
              {{ state.model?.d_tax_type_name || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="薪资所属期" label-align="right">
            <div>
              {{ state.model?.month || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="税款所属期" label-align="right">
            <div>
              {{ state.model?.tax_month || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="发放日期" label-align="right">
            <div>
              {{ state.model?.pay_date || "-" }}
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </ul>
      <ul
        style="
          flex: 1;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        "
      >
        <el-tabs
          v-model="state.activeName"
          class="detail-tabs"
          style="
            display: flex;
            flex-direction: column;
            overflow: hidden;
            flex: 1;
          "
        >
          <el-tab-pane label="算税明细" name="mx">
            <c_Record :id="props.data?.id"></c_Record>
          </el-tab-pane>
          <el-tab-pane label="个税核算" name="hs">
            <c_Account
              v-if="
                state.model.withholding_agent_type === 0 &&
                state.model.status === 1
              "
              :id="props.data?.id"
            ></c_Account>
            <div
              style="
                padding-top: 20px;
                text-align: center;
                color: #a2a2a2;
                color: #ffa500;
                font-size: 13px;
              "
              v-else
            >
              <text v-if="state.model.withholding_agent_type != 0">
                当前算税单为<strong style="color: #080">“外协算税单”</strong
                >，暂无个税核算数据~
              </text>
              <text v-if="state.model.status != 1">
                当前算税单状态不为<strong style="color: #080">“已算税”</strong
                >，暂无个税核算数据~
              </text>
            </div>
          </el-tab-pane>
        </el-tabs>
      </ul>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { calctax_read, calctax_submit, calctax_cancel } from "@/http/calctax";
import { ElMessage, ElMessageBox } from "element-plus";

import c_Record from "../CalcTax/Detail/Record.vue";
import c_Account from "../CalcTax/Detail/Account.vue";

export default {
  components: {
    c_Record,
    c_Account,
  },
  props: {
    data: Object,
  },
  setup(props) {
    const descDom = ref(null);
    const state = reactive({
      model: {},
      activeName: "mx",
      descHeight: "70px",
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      calctax_read(props.data?.id).then((res) => {
        if (res.status == 200) state.model = res.data.data;
      });
    };

    const onDescDomToggle = () => {
      if (state.descHeight == "70px")
        state.descHeight = descDom.value?.$el?.offsetHeight + 20 + "px";
      else state.descHeight = "70px";
    };

    const onSubmit = () => {
      ElMessageBox.confirm(
        `您确定要<strong style='color:#1e90ff'>提交</strong>算税吗？`,
        "提交",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      ).then(() => {
        calctax_submit({ id: props.data?.id }).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    const onCancel = () => {
      ElMessageBox.confirm(
        `您确定要<strong style='color:#f00'>取消</strong>该算税单吗？`,
        "取消",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      ).then(() => {
        calctax_cancel({ id: props.data?.id }).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };
    return { state, props, onSubmit, onCancel, descDom, onDescDomToggle };
  },
};
</script>
<style scoped>
.essential-detail-record-table {
  width: 100%;
  font-size: 15px;

  & td:nth-child(2n + 1) {
    white-space: nowrap;
    color: #a2a2a2;
    text-align: right;
  }

  & td:nth-child(2n) {
    text-align: left;
    width: 27%;
  }
}
</style>
